const INCIDENT_STAGE_TRANSITIONS = new Map([
  ["assigned", "in_progress"],
  ["in_progress", "resolved"],
]);

const manage_incident_stage_helper = {
  get_incident_stage_index(status) {
    const normalized_status = String(status || "pending").toLowerCase().replace(/\s+/g, "_");
    const stage_index = this.incident_stages.findIndex((stage) => stage.value === normalized_status);
    return Math.max(stage_index, 0);
  },
  is_incident_stage_complete(stage_index) {
    const incident_status = Reflect.get(Object(this.selected_incident), "incident_status");
    return stage_index <= this.get_incident_stage_index(Reflect.get(Object(incident_status), "name"));
  },
  can_select_incident_stage(status) {
    return INCIDENT_STAGE_TRANSITIONS.get(this.get_selected_incident_status()) === status;
  },
  get_selected_incident_status() {
    const incident_status = Reflect.get(Object(this.selected_incident), "incident_status");
    return String(Reflect.get(Object(incident_status), "name") || "pending")
      .toLowerCase()
      .replace(/[\s-]+/g, "_");
  },
  set_incident_stage(status) {
    const next_status = INCIDENT_STAGE_TRANSITIONS.get(this.get_selected_incident_status());
    if (next_status !== status) return null;
    return this.update_incident_status(status);
  },
  start_selected_incident() {
    return this.set_incident_stage("in_progress");
  },
  resolve_selected_incident() {
    if (this.get_selected_incident_status() === "in_progress" && this.resolved_incident_status) {
      return this.set_incident_stage(this.resolved_incident_status.name);
    }
    return null;
  },
};

export default manage_incident_stage_helper;
